import { Select, Option } from 'element-ui'
import HttpFactory from '@/mixins/http.factory';
export default {
	name:'configure-app',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			configData:null,
		}
	},
	created(){
		this.init();
	},
	methods:{
		async init(){
			let _self=this;
			_self.mondayInfo=await _self.fn().getMondayData_Child(_self.$route.params.appId,_self.$route.params.installationId,_self.$route.params.hdBoardId,_self.$route.params.hdItemId);
			await _self.getConfigData();
		},
		async getConfigData(){
			let _self=this;
			_self.fn().clearMessage();
			_self.fn().showLoader(true);
			let url =`userData/get`;
			let data={auth:_self.mondayInfo.credentials};
			let response=await _self.post(url,data);
			_self.fn().showLoader(false);
			let configData=response.data.Data;
			_self.configData=configData;
		},
		saveConfigDataFn(){
			let _self=this;
			_self.fn().clearMessage();
			let url=`userData/update`;
			let data=_self.configData;
			
			data.auth=_self.mondayInfo.credentials;
			data.user=_self.mondayInfo.user;
			_self.fn().showLoader(true);
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				let data=response.data.Data;
				if(response.data.Success){
					let userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Customize View data saved Successfully`]}
					_self.userMsg=userMsg;
				}
				//_self.sendDataToParent(response.data);
			}).catch(error=>{
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		closeDialog(data) {
			let _self= this;
			_self.fn().close_monday_modal(data);
		},
        sendDataToParent(data) {
            let _self = this;
            _self.closeDialog(data);
		},
	},
	components:{[Select.name]: Select,[Option.name]: Option}
}

